var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 12.5C25.5 19.3925 19.8925 25 13 25C6.1075 25 0.5 19.3925 0.5 12.5C0.5 5.6075 6.1075 0 13 0C19.8925 0 25.5 5.6075 25.5 12.5ZM23.6707 12.1951C23.6707 6.47939 19.0206 1.82927 13.3049 1.82927V2.65854C18.5637 2.65854 22.8415 6.93673 22.8415 12.1951H23.6707ZM12.6951 4.26829C17.4022 4.26829 21.2317 8.09781 21.2317 12.8049H20.378C20.378 8.5686 16.9314 5.12195 12.6951 5.12195V4.26829ZM19.4024 12.1951C19.4024 8.83293 16.6671 6.09756 13.3049 6.09756V6.91057C16.2187 6.91057 18.5894 9.2813 18.5894 12.1951H19.4024ZM13.3049 9.14634C14.9856 9.14634 16.3537 10.5139 16.3537 12.1951C16.3537 13.8763 14.9856 15.2439 13.3049 15.2439C11.6241 15.2439 10.2561 13.8763 10.2561 12.1951C10.2561 10.5139 11.6241 9.14634 13.3049 9.14634ZM12.6951 18.0894C9.7813 18.0894 7.41057 15.7187 7.41057 12.8049H6.59756C6.59756 16.1671 9.33293 18.9024 12.6951 18.9024V18.0894ZM5.62195 12.1951C5.62195 16.4314 9.0686 19.878 13.3049 19.878V20.7317C8.59781 20.7317 4.76829 16.9022 4.76829 12.1951H5.62195ZM13.3049 21.7317C8.04607 21.7317 3.76829 17.4535 3.76829 12.1951H2.93902C2.93902 17.9109 7.58915 22.561 13.3049 22.561V21.7317Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.42d5a54d.svg";
export { ForwardRef as ReactComponent };